import React from 'react';
import {ScrollView} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {FlexView, Spacer, Spacing} from '/component/base/Storybook';

import DestructiveButtonStory from './Destructive';
import PrimaryButtonStory from './Primary';
import SecondaryButtonStory from './Secondary';
import SecondaryTextLinkButtonStory from './SecondaryTextLink';
import TextLinkButtonStory from './TextLink';

storiesOf('base', module).add('Button', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <PrimaryButtonStory />
        <Spacer size={24} />
        <SecondaryButtonStory />
        <Spacer size={24} />
        <TextLinkButtonStory />
        <Spacer size={24} />
        <SecondaryTextLinkButtonStory />
        <Spacer size={24} />
        <DestructiveButtonStory />
      </FlexView>
    </Spacing>
  </ScrollView>
));
